module.exports = __webpack_public_path__ + "img/waiting-relax.43f43ce8.svg";